import React, { useEffect, useState } from 'react';
import { Row, Col, Button, message, Space } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getPurchaseOrderList } from '../ducks/actions'
import { removePurchaseOrder, bulkRemovePurchaseOrders, createGR } from '../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import Search from './components/Search';
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import dayjs from 'dayjs';
import { PlusOutlined } from '@ant-design/icons';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { useTranslate } from 'Translate';

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const orders = useSelector((state) => state.inventory.purchaseOrders);
  const meta = useSelector((state) => state.inventory.purchaseOrdersOption);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const allowedEdit = allowed([AllRoles.INVENTORY.PURCHASE_ORDER], 'write');
  const allowedDelete = allowed([AllRoles.INVENTORY.PURCHASE_ORDER], 'delete');
  const [outlets, setOutlets] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [vendors, setVendors] = useState([]);
  const globalListQuery = useSelector((state) => state.global.listQueryItems);
  const i18n = useTranslate();
    const { t } = i18n;

  const colName = [
    {
      title: t("Inventory.po_no"),
      dataIndex: 'reference',
      key: 'reference',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Inventory.po_date"),
      dataIndex: 'date',
      key: 'date',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Inventory.delivery_date"),
      dataIndex: 'delivery_date',
      key: 'delivery_date',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Outlet.outlet"),
      dataIndex: 'location_code',
      key: 'location_code',
      className: 'enable-click',
      sorter: true,
      render: (text, record) =>
        <span>{text} {record?.location_desc}</span>
    },
    {
      title: t("Inventory.supplier"),
      dataIndex: 'vendor_name',
      key: 'vendor_name',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Inventory.created_by"),
      dataIndex: 'created_by_name',
      key: 'created_by_name',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Inventory.created_at"),
      dataIndex: 'created_at',
      key: 'created_at',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Inventory.confirm_date_time"),
      dataIndex: 'confirmed_at',
      key: 'confirmed_at',
      className: 'enable-click',
      sorter: true,
      render: (text) => <span>{text || "-"}</span>
    },
    {
      title: t("General.status"),
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (text, record) =>
        <div className='flex align-items-center'>
          <span className={text === "Confirmed" ? "c-success" : text === "Pending" ? "c-pending" : "c-danger"}>
            {t(`General.${text?.toLowerCase()}`)}
          </span>
          {" "}
          {
            // allowed([Roles.USERS], 'write') &&
            (text === "Pending" || text === "Confirmed") &&
            allowedEdit &&
            <Space size={10} >
              
              {
                (text === "Pending" && record.item_count > 0) &&
                <>
                  {"("}
                    <a className='pointer' onClick={() => onAction(record.id, "confirm")}>
                      {t("General.confirm")}
                    </a>
                  {")"}
                </>
              }
              {/* <a className='pointer c-danger' onClick={() => onAction(record.id, "cancel")}>
                Cancel
              </a> */}
            </Space>
          }
        </div>
    },
    {
      title: t("Inventory.create_gr"),
      dataIndex: 'allowed',
      key: 'allowed',
      align: 'center',
      render: (text, record) => {
        return (
          <>
            {
              record?.can_create_gr && allowedEdit && allowed([AllRoles.INVENTORY.GOOD_RECEIVE], 'write') &&
              <Button size="large" htmlType='button' className='c-success' onClick={() => onCreateGR(record.id)}>
                <PlusOutlined />
              </Button> 
            }
            {
              record?.stock_in_id &&
              <Link className='ml-1' to={`/inventory/good-receive/${record?.stock_in_id}`}>{">"} GRN</Link>
            }
          </>
        )
      }
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) =>
        <ActionButton
          title="purchase_order"
          btnAction1={() => navigate(`/inventory/purchase-order/${record.id}`)}
          recordId={record.id}
          onRemove={(record?.status === "Pending" && allowedDelete) && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ]

  const addNew = () => navigate('/inventory/purchase-order/add');

  const btnList = [
    {
      title: t("Confirm.remove_select_purchase_orders"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("New.purchase_order")}`,
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    if(!globalListQuery.purchaseOrderListQuery) {
      dispatch(getPurchaseOrderList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('purchaseOrderListQuery', 1, limit, '', '', null, props.setLoading));
    } else {
      const {page, limit, sortOrder, sortColKey, searchValue} = globalListQuery.purchaseOrderListQuery
      dispatch(getPurchaseOrderList(page, limit, sortOrder, sortColKey, searchValue, props.setLoading));
      setPage(page);
      setLimit(limit);
      setSearchVal(searchValue);
    }
  }, []);

  useEffect(() => {
    if(meta) {
      if('locations' in meta) {
        let temp = [];
        meta?.locations?.map((item, index) => {
          if(index === 0) {
            temp.push({
              label: t("General.all_outlets"),
              value: ""
            })
          }
          temp.push({
            label: `${item.code} ${item.desc}`,
            value: item.id
          })
        });
        setOutlets(temp);
      }

      if ("statuses" in meta) {
        let temp2 = [];
        meta.statuses?.map((x, ind) => {
          if (ind === 0) {
            temp2.push({
              label: t("General.all_status"),
              value: ""
            });
          }
          temp2.push({
            label: x,
            value: x
          })
        });
        setStatuses(temp2);
      }

      if ('vendors' in meta) {
        let temp = [];
        meta?.vendors?.map((item, index) => {
          if (index === 0) {
            temp.push({
              label: "All Vendors",
              value: ""
            })
          }
          temp.push({
            label: `${item.code} ${item.name}`,
            value: item.id
          })
        });
        setVendors(temp);
      }
    }
  }, [meta])

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.status !== 'Pending'
    }),
  };

  const onAction = async (poId, status) => {
    props.setLoading(true);

    const payload = {
      purchase_order_id: poId,
      status_event: status
    }

    await removePurchaseOrder(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.update_purchase_order_status"));
        setTimeout(() => dispatch(getPurchaseOrderList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('purchaseOrderListQuery', page, limit, '', '', searchVal, props.setLoading))
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onRemove = async (poId) => {
    props.setLoading(true);

    const payload = {
      purchase_order_id: poId,
      status_event: 'remove'
    }

    await removePurchaseOrder(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.remove_purchase_order"));
        setTimeout(() => dispatch(getPurchaseOrderList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('purchaseOrderListQuery', page, limit, '', '', searchVal, props.setLoading))
      }else{
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      purchase_orders: JSON.stringify(selectedRowKeys)
    }

    await bulkRemovePurchaseOrders(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("Success.remove_purchase_orders"));
        setPage(1);
        setSearchVal(null);
        setTimeout(() => dispatch(getPurchaseOrderList(1, limit, '', '', null, props.setLoading)), 500);
        dispatch(getListQueryItems('purchaseOrderListQuery', 1, limit, '', '', null, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getPurchaseOrderList(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
      dispatch(getListQueryItems('purchaseOrderListQuery', pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading))
    } else {
      dispatch(getPurchaseOrderList(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
      dispatch(getListQueryItems('purchaseOrderListQuery', pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading))
    }
  }

  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        reference: search?.reference,
        status: search.status.value,
        outlet: search?.outlet?.value,
        vendor: search?.vendor?.value,
        date: search.date ? dayjs(search.date).format("YYYY-MM-DD") : "",
      };
      setSearchVal(searching);
      dispatch(getPurchaseOrderList(1, limit, '', '', searching, props.setLoading));
      dispatch(getListQueryItems('purchaseOrderListQuery', 1, limit, '', '', searching, props.setLoading))
    } else {
      setSearchVal(null);
      dispatch(getPurchaseOrderList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('purchaseOrderListQuery', 1, limit, '', '', null, props.setLoading))
    }
  };

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click"))
          navigate(`/inventory/purchase-order/${record.id}`)
      },
    };
  };

  const onCreateGR = async (poId) => {
    props.setLoading(true);

    const payload = {
      purchase_order_id: poId
    }

    await createGR(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.create_gr"));
        setTimeout(() => navigate(`/inventory/good-receive/${res.data.data}?isRedirected=true`), 500);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={t("General.purchase_orders")} btnList={allowedEdit && btnList} btnHidden={selectedRowKeys.length <= 0} />
        </Col>
        <Col span={24} className="clickRow">
          <ListCard
            Search={Search}
            onSearch={onSearch}
            searchVal={globalListQuery.purchaseOrderListQuery?.searchValue}
            onRow={onClickRow}
            // listClass="nopad"
            ListData={orders?.list?.map(x => ({ ...x, key: x.id }))}
            ListCol={colName}
            rowSelection={allowedEdit && rowSelection}
            onChange={onTableChange}
            pagination={{
              total: orders?.total_count,
              current: page,
              pageSize: limit
            }}
            field1={statuses}
            field2={outlets}
            field3={vendors}
          />
        </Col>
      </Row>
    </>
  )
}